import React from 'react';
import classNames from 'classnames';
import { Logo, NamedLink } from '../../components';

import css from './TopbarBlank.css';

// children render on the right, e.g. the onboarding account menu
const TopbarBlank = ({ children }) => {
  return (
    <div className={css.root}>
      <div className={classNames(css.container, { [css.containerWithActions]: !!children })}>
        <NamedLink className={css.logoLinkDesktop} name="LandingPage">
          <Logo format="desktop" className={css.logo} alt="Logo" />
        </NamedLink>
        {children}
      </div>
    </div>
  );
};

export default TopbarBlank;
